import {
  CommonResponse,
  WECHAT_BOUND_QRCODE,
  WECHAT_GET_AUTHURL,
  WECHAT_LOGIN,
  WECHAT_UNBIND,
  WECHAT_URL_SIGN,
  WECHAT_LOGIN_QR,
  WECHAT_LOGIN_QR_CALLBACK,
  WECHAT_CHECK_QR_CHECK,
  netClient,
  WECHAT_BIND,
  WECHAT_MINIAPP_LOGIN,
  WECHAT_TEMP_QR,
  clientType,
  CLIENT_TYPE_WEB,
  CLIENT_TYPE_WECHAT
} from '@/apis/api'
import type { AccountDTO, UserInfoDTO } from '../user/users'
import { type Ref, computed, onMounted, ref } from 'vue'
import { handleErr } from '@/composables/exception/handler'
import { CODE_OK } from '@/apis/code'
import { ElMessage } from 'element-plus'
import { MAX_NAME_CHARS, minifyString } from '@/utils/util'
import { isInWechat, isIOS, isMobile } from '@/utils/device'
import { renderMessage } from '@/utils/render'
import {
  type CreateInvitationCommand,
  createInvitation,
  type MemorialInvitationResponse
} from '@/composables/memorize/memorize'
import { OPEN_URL_INVITATION } from '@/constants'
import { currentUser } from '@/composables/user/users'
import Clipboard from 'clipboard'
import { nextTick } from 'vue'
import i18n from '@/utils/i18n'
import { currentLang } from '@/composables/settings/storage'
import { imageTextShare, InvitationShare } from '@/composables/wechat/templatePresets'

// 微信签名
export async function getWechatSignature() {
  let currentUrl: string = ''
  console.log('isIOS():', isIOS())
  if (isIOS()) {
    currentUrl = localStorage.getItem('firstUrl') || ''
  } else {
    currentUrl = window.location.href
  }
  // const currentUrl = window.location.href

  console.log('签名用的url!!!!!!!!!!!!!!!!!: ', currentUrl)
  const { data, error, statusCode } = await wechatSignUrl(currentUrl)
  console.log('data', data)
  if (error.value) {
    console.log('error', error)
    handleErr(data, error, statusCode)
    return false
  } else {
    const resData = data as unknown as Ref<CommonResponse<WechatUrlSignature>>
    console.log('resData', resData)
    if (resData.value.code === CODE_OK) {
      const response: WechatUrlSignature = resData.value.data
      return response
    } else {
      return null
    }
  }
}

// 导出响应式状态，用于跟踪邀请创建过程
export const invitationState = {
  invitationCode: ref(''),
  inviteLink: ref(''),
  creating: ref(false),
  loaded: ref(true),
  error: ref(false)
}

// 用于处理Clipboard的回调
export type ClipboardCallbacks = {
  onSuccess?: () => void
  onError?: () => void
}

/**
 * 创建邀请链接
 * @param serviceId 服务ID
 * @param role 角色
 * @param expireDays 过期天数
 * @param shareConfig 可选的分享配置
 * @param clipboardElement 可选的剪贴板元素
 * @param clipboardCallbacks 可选的剪贴板回调
 * @returns 成功返回邀请码，失败返回null
 */
export async function getInvitation(
  serviceId: string,
  role: string,
  expireDays: number,
  shareConfig?: {
    name: string
    avatarUrl: string
  },
  clipboardElement?: HTMLElement | null,
  clipboardCallbacks?: ClipboardCallbacks,
  yearPeriod?: string
) {
  console.log('role:', role)
  try {
    // 创建过期日期
    let currentDate = new Date()
    currentDate.setDate(currentDate.getDate() + expireDays)
    // 保证页面稳定后再进行操作

    invitationState.creating.value = true
    // 调用API创建邀请
    const { data, error, statusCode } = await createInvitation({
      serviceId: serviceId,
      role: role,
      expireAt: currentDate.toUTCString()
    } as unknown as CreateInvitationCommand)

    invitationState.creating.value = false

    invitationState.loaded.value = false

    // 处理创建结果
    if (error.value) {
      handleErr(data, error, statusCode)
      invitationState.error.value = true
      return null
    }

    const resData = data as unknown as Ref<CommonResponse<MemorialInvitationResponse>>
    if (resData.value.code !== CODE_OK) {
      invitationState.error.value = true
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
      return null
    }

    // 成功获取邀请码
    const response: MemorialInvitationResponse = resData.value.data
    invitationState.invitationCode.value = response.invitationCode
    invitationState.inviteLink.value =
      location.protocol + '//' + location.host + OPEN_URL_INVITATION + response.invitationCode
    invitationState.loaded.value = true
    invitationState.error.value = false
    // 设置剪贴板
    if (clipboardElement) {
      setupClipboard(clipboardElement, invitationState.inviteLink.value, shareConfig?.name || '', clipboardCallbacks)
    }

    // 配置微信分享
    if (isInWechat() && shareConfig) {
      const avatarUrl = shareConfig.avatarUrl
      //纪念分享页只有邀请函，只需要配置邀请函预设模版
      const invitationShare = new InvitationShare(
        i18n.global.t('invitation.invite_for', {
          inviter: currentUser.value.user?.name?.fullName || '',
          name: shareConfig.name
        }),
        'https://lp-file.lifepage.cc/img/miniapp_share_card.jpg',
        invitationState.inviteLink.value,
        i18n.global.t('invitation.miniprogram_title'),
        avatarUrl,
        i18n.global.t('home.somebody_s_mem', { name: shareConfig.name }),
        yearPeriod || '',
        i18n.global.t('invitation.invite_for', {
          inviter: currentUser.value.user?.name?.fullName || '',
          name: shareConfig.name
        }),
        'https://lp-file.lifepage.cc/operation/20251015193252128_SN95V2Tesq.png'
      )
      if (inMiniprograme.value) {
        navigateToMiniAppShare(invitationShare)
      } else {
        await getShareInfo(
          i18n.global.t('invitation.invite_for', {
            inviter: currentUser.value.user?.name?.fullName || '',
            name: shareConfig.name
          }),
          i18n.global.t('invitation.share_desc'),
          'https://lp-file.lifepage.cc/img/miniapp_share_card.jpg', // 卡片图片,先写死
          invitationState.inviteLink.value
        )
      }
    }
    return response.invitationCode
  } catch (e) {
    console.error('创建邀请过程中发生错误:', e)
    invitationState.error.value = true
    return null
  } finally {
    // 在完成后延迟重置creating状态

    invitationState.creating.value = false
  }
}

// 跳转到小程序分享页
export function navigateToMiniAppShare(shareInfo: InvitationShare | imageTextShare) {
  if (typeof window === 'undefined') return
  import('weixin-js-sdk').then((module) => {
    const wx = module.default || module
    wx.miniProgram.navigateTo({
      url: shareInfo.url
    })
  })
}

// h5分享
export async function getShareInfo(
  title: string, // 卡片title part1
  shareDesc: string, // 卡片title 这里讣告部分要修改，目前讣告的卡片标题是title+shareDesc，应该修改成调用方法时就直接拼接
  shareImg: string, // 卡片url
  linkToUse: string // 要分享的url
) {
  // 微信有bug，在ios环境中，可能会把首次进入的地址当成realAuthUrl（而不是window.location.href），因此需要特殊处理
  // 在App.vue中记录首次进入的地址，如果是ios设备，则把签名的url改成首次进入的地址，其他设备则正常使用window.location.href
  let currentUrl: string = ''
  console.log('isIOS():', isIOS())
  if (isIOS()) {
    currentUrl = localStorage.getItem('firstUrl') || ''
  } else {
    currentUrl = window.location.href
  }
  console.log('签名用的url!!!!!!!!!!!!!!!!!: ', currentUrl)
  const { data, error, statusCode } = await wechatSignUrl(currentUrl)
  if (error.value) {
    //handleErr(data, error, statusCode)
    return false
  } else {
    const resData = data as unknown as Ref<CommonResponse<WechatUrlSignature>>
    if (resData.value.code === CODE_OK) {
      const config: WechatUrlSignature = resData.value.data
      configureShare(config, title, shareDesc, shareImg, linkToUse)
      return true
    } else {
      return false
    }
  }
}

async function configureShare(
  config: WechatUrlSignature,
  title: string,
  shareDesc: string,
  shareImg: string,
  linkToUse: string
) {
  if (typeof window === 'undefined') return
  const module = await import('weixin-js-sdk')
  const wx = module.default || module

  // 设置微信配置
  wx.config({
    debug: false,
    appId: config.appid, // 必填，公众号的唯一标识
    timestamp: config.timestamp, // 必填，生成签名的时间戳
    nonceStr: config.nonceStr, // 必填，生成签名的随机串
    signature: config.signature, // 必填，签名
    jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
  })
  console.log('配置分享参数!!!!!!:', title, shareDesc, shareImg, linkToUse)

  // 微信SDK准备就绪回调
  wx.ready(function () {
    try {
      wx.updateAppMessageShareData({
        title: title, // 分享标题
        desc: shareDesc, // 分享描述
        link: linkToUse, // 分享链接
        imgUrl: shareImg, // 分享图标
        success: function () {
          console.log('设置分享给朋友成功')
        },
        cancel: function () {
          console.log('用户取消分享给朋友')
        },
        fail: (res: any) => {
          console.error('设置分享给朋友失败:', res)
        }
      })
      //分享到朋友圈
      wx.updateTimelineShareData({
        title: title, // 分享标题
        link: linkToUse, // 分享链接
        imgUrl: shareImg, // 分享图标
        success: function () {
          console.log('设置分享到朋友圈成功')
        },
        cancel: function () {
          console.log('用户取消分享到朋友圈')
        },
        fail: (res: any) => {
          console.error('设置分享到朋友圈失败:', res)
        }
      })
    } catch (error) {
      console.error('设置微信分享时发生异常:', error)
    }
  })
}

/**
 * 设置剪贴板功能
 */
function setupClipboard(element: HTMLElement, linkValue: string, name: string = '', callbacks?: ClipboardCallbacks) {
  let clipboard = new Clipboard(element, {
    text: () => {
      if (name) {
        return (
          i18n.global.t('invitation.invite_link', {
            inviter: currentUser.value.user?.name?.fullName || '',
            name: name
          }) + linkValue
        )
      }
      return linkValue
    }
  })

  clipboard.on('success', () => {
    console.log('inviteLink:', linkValue)
    ElMessage({
      message: renderMessage('复制成功'),
      type: 'success'
    })

    if (callbacks?.onSuccess) {
      callbacks.onSuccess()
    }
  })

  clipboard.on('error', () => {
    ElMessage({
      message: renderMessage('复制失败，请手动复制'),
      type: 'warning'
    })

    if (callbacks?.onError) {
      callbacks.onError()
    }
  })

  return clipboard
}

export interface AuthUrl {
  url: string
}

export function getWechatAuthUrl(authUrl: string, hasUserInfo: boolean = true) {
  return netClient.request<CommonResponse<AuthUrl>>(WECHAT_GET_AUTHURL, 'get', {
    authUrl: authUrl,
    hasUserInfo: hasUserInfo
  })
}

export function wechatLogin(state: string, code: string) {
  return netClient.request<CommonResponse<AccountDTO>>(WECHAT_LOGIN, 'post', { state: state, code: code })
}

export function miniAppLogin(state: string, code: string) {
  return netClient.request<CommonResponse<AccountDTO>>(WECHAT_MINIAPP_LOGIN, 'post', { state: state, code: code })
}

export function bindWechat(state: string, code: string) {
  return netClient.request<CommonResponse<UserInfoDTO>>(WECHAT_BIND, 'post', { state: state, code: code })
}

export function unbindWechat() {
  return netClient.request<CommonResponse<UserInfoDTO>>(WECHAT_UNBIND, 'post', {})
}

export interface WechatUrlSignature {
  nonceStr: string
  appid: string
  timestamp: number
  signature: string
}

export function wechatSignUrl(url: string) {
  return netClient.request<CommonResponse<WechatUrlSignature>>(WECHAT_URL_SIGN, 'post', { url: url })
}

const _showShareViaWechat = ref<boolean>(false)
export const showShareViaWechat = _showShareViaWechat

export function getWechatDefaultBindUrl() {
  return netClient.request<CommonResponse<string>>(WECHAT_BOUND_QRCODE, 'get', {})
}

export interface WechatLoginQr {
  appId: string
  state: string
  expireTime: number
  redirectUrl: string
}

export function getWechatLoginQr() {
  return netClient.request<CommonResponse<WechatLoginQr>>(WECHAT_LOGIN_QR, 'get', {})
}

export function wechatCallback(code: string, state: string) {
  return netClient.request<CommonResponse<AccountDTO>>(WECHAT_LOGIN_QR_CALLBACK, 'post', { code: code, state: state })
}

export function wechatCheck(state: string) {
  return netClient.request<CommonResponse<AccountDTO>>(WECHAT_CHECK_QR_CHECK, 'get', { state: state })
}

export interface QrTempBindCommand {
  content: string
  url: string
  actionTxt: string
  expireSeconds: number
}

export interface QrTempBindResult {
  sceneStr: string
  qrUrl: string
  expireSeconds: number
}

/**
 *
 * @param command
 *
 * @returns
 * sceneStr - 场景值
 * qrUrl - 二维码
 * expireSeconds - 过期时间
 */
export function getWechatTempQr(qrCommand: QrTempBindCommand) {
  return netClient.request<CommonResponse<QrTempBindResult>>(WECHAT_TEMP_QR, 'post', qrCommand)
}
